import React, { FC } from 'react';
import { DrivingDailyData } from './DrivingDailyData/DrivingDailyData';

export const DrivingDailyDataPage: FC = () => {
  return <DrivingDailyData />;
};
